import Axios from "axios";
import axiosClient from "./axiosClient";

const BaseURL: string = process.env.REACT_APP_API_URL ?? "";

interface IFaqResponse {
  name: string;
  questions: {
    question: string;
    answer: string;
  }[];
}

async function fetchFAQData(): Promise<IFaqResponse[] | null> {
  try {
    console.log("Fetch");
    const response = await axiosClient.get(`/faq/get-faq-data`);

    if (response.status !== 200) {
      console.warn("API call response is not 200 OK!");
      return null;
    }
    return response.data.data;
  } catch (error: any) {
    console.error("Error fetching FAQ data:", error);
    return null;
  }
}

export default fetchFAQData;
